import { authenticated } from '../../helpers/auth-header';
import { CacheConstants, CacheUtils } from '../../cache';
import insighttAPI from '../clients/insightt-api-client';
import { reportsEndpoints } from '../endpoints';

const getMTDRepossessed = async (dateStart, dateEnd, timezoneOffset) =>
  authenticated(insighttAPI).get(reportsEndpoints.getMTDRepossessedAPI(dateStart, dateEnd, timezoneOffset));

const getMTDMissedRepossessed = (dateStart, dateEnd, timezoneOffset) =>
  authenticated(insighttAPI).get(reportsEndpoints.getMTDMissedRepossessedAPI(dateStart, dateEnd, timezoneOffset));

const getMTDAssigned = async (dateStart, dateEnd, timezoneOffset) =>
  authenticated(insighttAPI).get(reportsEndpoints.getMTDAssignedAPI(dateStart, dateEnd, timezoneOffset));

const getMTDYTDCompanyUncategorized = async (timezoneOffset) =>
  authenticated(insighttAPI).get(reportsEndpoints.getMTDYTDCompanyUncategorizedAPI(timezoneOffset));

const getPCYMCompanyStats = async (year, timezoneOffset) => {
  const API_KEY = CacheConstants.REPORTS_COMPANY_2_YEARS(year, timezoneOffset);
  const cache = CacheUtils.getCache(API_KEY);
  if (cache) {
    return Promise.resolve({ data: cache, ok: true, fromCache: true });
  }
  const response = await authenticated(insighttAPI).get(
    reportsEndpoints.getPCYMCompanyStatsAPI(year, timezoneOffset),
  );
  CacheUtils.setCache(API_KEY, response.data, 10);
  return response;
};

const getYTDCompanyStats = async (dateStart, timezoneOffset) =>
  authenticated(insighttAPI).get(reportsEndpoints.getYTDCompanyStatsAPI(dateStart, timezoneOffset));

const getDailyViewStats = async (date, timezoneOffset, branchId) => {
  // TODO: move all the daily reports services to graphql
  const response = await authenticated(insighttAPI).get(
    reportsEndpoints.getDailyViewStatsAPI(date, timezoneOffset, branchId),
  );
  response.data.data = {
    ...response.data.data,
  };
  return response;
};

const getTopAgents = async (dateStart, dateEnd, timezoneOffset) => {
  const API_KEY = CacheConstants.AGENTS_BY_RANK(dateStart, dateEnd, timezoneOffset);
  const cache = CacheUtils.getCache(API_KEY);
  if (cache) {
    return Promise.resolve({ data: cache, ok: true, fromCache: true });
  }
  const response = await authenticated(insighttAPI).get(
    reportsEndpoints.getTopAgentsAPI(dateStart, dateEnd, timezoneOffset),
  );
  CacheUtils.setCache(API_KEY, response.data, 10);
  return response;
};

const getTopSpotters = async (dateStart, dateEnd, timezoneOffset) => {
  const API_KEY = CacheConstants.SPOTTER_BY_RANK(dateStart, dateEnd, timezoneOffset);
  const cache = CacheUtils.getCache(API_KEY);
  if (cache) {
    return Promise.resolve({ data: cache, ok: true, fromCache: true });
  }
  const response = await authenticated(insighttAPI).get(
    reportsEndpoints.getTopSpottersAPI(dateStart, dateEnd, timezoneOffset),
  );
  CacheUtils.setCache(API_KEY, response.data, 10);
  return response;
};
const getMTDYTDEmployeesStats = async (mtdStartDate, mtdEndDate, ytdStartDate, ytdEndDate, timezoneOffset) =>
  authenticated(insighttAPI).get(
    reportsEndpoints.getMTDYTDEmployeesStatsAPI(
      mtdStartDate,
      mtdEndDate,
      ytdStartDate,
      ytdEndDate,
      timezoneOffset,
    ),
  );

const getMTDYTDClientUncategorized = (clientId, timezoneOffset) =>
  authenticated(insighttAPI).get(reportsEndpoints.getMTDYTDClientUncategorizedAPI(clientId, timezoneOffset));

const getYTDClientStats = (clientId, timezoneOffset) =>
  authenticated(insighttAPI).get(reportsEndpoints.getYTDClientStatsAPI(clientId, timezoneOffset));

const getMTDPastYearsClientStats = (clientId, timezoneOffset, currentDay) =>
  authenticated(insighttAPI).get(
    reportsEndpoints.getMTDPastYearsClientStatsAPI(clientId, timezoneOffset, currentDay),
  );

const getDailyEmployeesShift = (date, timezoneOffset) =>
  authenticated(insighttAPI).get(reportsEndpoints.getDailyEmployeesShiftAPI(date, timezoneOffset));

const getWeeklyEmployeesShift = (startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(reportsEndpoints.getWeeklyEmployeesShiftAPI(startDate, endDate, timezoneOffset));

const sendWeeklyRepossessionsReportNow = () =>
  authenticated(insighttAPI).post(reportsEndpoints.sendWeeklyRepossessionsReportNowAPI(), {});

export const reportsService = {
  getMTDRepossessed,
  getMTDMissedRepossessed,
  getMTDAssigned,
  getMTDYTDCompanyUncategorized,
  getPCYMCompanyStats,
  getYTDCompanyStats,
  getTopAgents,
  getTopSpotters,
  getMTDYTDEmployeesStats,
  getMTDYTDClientUncategorized,
  getYTDClientStats,
  getMTDPastYearsClientStats,
  getDailyEmployeesShift,
  getWeeklyEmployeesShift,
  getDailyViewStats,
  sendWeeklyRepossessionsReportNow,
};
